import { assetUrl } from "../../utils/api";

export function getAdminHeaders(withJson = false) {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("admin_token") || ""}`,
  };

  if (withJson) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
}

export function toAssetUrl(url) {
  if (!url) {
    return "";
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  const normalized = String(url).replace(/\\/g, "/");

  let path = normalized;
  if (!path.startsWith("/")) {
    if (path.startsWith("uploads/")) {
      path = `/${path}`;
    } else {
      const uploadsIndex = path.indexOf("uploads/");
      if (uploadsIndex >= 0) {
        path = `/${path.slice(uploadsIndex)}`;
      } else {
        path = `/${path}`;
      }
    }
  }

  // 兼容旧路径 /static/uploads/...
  if (path.includes("/static/uploads/")) {
    path = path.replace("/static/uploads/", "/uploads/");
  }

  return assetUrl(path);
}

export async function adminRequest(path, options = {}) {
  const res = await fetch(path, options);
  let data = null;

  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (res.status === 401) {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_name");
    window.location.href = "/admin/login";
    throw new Error("管理员未登录");
  }

  return { res, data };
}

export async function uploadAdminImage(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch("/api/admin/upload-image", {
    method: "POST",
    headers: getAdminHeaders(),
    body: form,
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.detail || "图片上传失败");
  }
  return data.url;
}

export async function uploadEbookCover(file) {
  const form = new FormData();
  form.append("file", file);
  const { res, data } = await adminRequest("/api/admin/ebooks/upload-cover", {
    method: "POST",
    headers: getAdminHeaders(),
    body: form,
  });
  if (!res.ok) {
    throw new Error(data?.detail || "封面上传失败");
  }
  return data.cover_path;
}

export async function uploadEbookFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { res, data } = await adminRequest("/api/admin/ebooks/upload-file", {
    method: "POST",
    headers: getAdminHeaders(),
    body: form,
  });
  if (!res.ok) {
    throw new Error(data?.detail || "电子书上传失败");
  }
  return data;
}
